import ProfilesContainer from './Profiles';
import reducer from './profiles.reducer';

/**
 * Profiles module exports
 */
export {
    ProfilesContainer as default,
    reducer,
};



// WEBPACK FOOTER //
// ./src/js/Profiles/index.js